import { combineReducers } from 'redux';
import { ICareTeamAssignmentPreview } from '@liquid-state/pephealth-client';
import { IState } from '@redux/reducer';
import {
  ClearOrganisationUserCareTeamAssignmentPreview,
  FetchOrganisationUserCareTeamAssignmentPreview,
  OrganisationUserCareTeamAssignmentPreviewFailed,
  OrganisationUserCareTeamAssignmentPreviewLoaded,
} from './actions';

type PreviewAction =
  | FetchOrganisationUserCareTeamAssignmentPreview
  | OrganisationUserCareTeamAssignmentPreviewLoaded
  | OrganisationUserCareTeamAssignmentPreviewFailed
  | ClearOrganisationUserCareTeamAssignmentPreview;

function loading(state = false, action: PreviewAction): boolean {
  switch (action.type) {
    case 'organisationUserCareTeamPreview/fetch':
      return true;
    case 'organisationUserCareTeamPreview/loaded':
    case 'organisationUserCareTeamPreview/failed':
    case 'organisationUserCareTeamPreview/clear':
      return false;
    default:
      return state;
  }
}

function failed(state = false, action: PreviewAction): boolean {
  switch (action.type) {
    case 'organisationUserCareTeamPreview/fetch':
    case 'organisationUserCareTeamPreview/loaded':
    case 'organisationUserCareTeamPreview/clear':
      return false;
    case 'organisationUserCareTeamPreview/failed':
      return true;
    default:
      return state;
  }
}

function assignments(state: ICareTeamAssignmentPreview[] = [], action: PreviewAction) {
  switch (action.type) {
    case 'organisationUserCareTeamPreview/fetch':
    case 'organisationUserCareTeamPreview/failed':
    case 'organisationUserCareTeamPreview/clear':
      return [];
    case 'organisationUserCareTeamPreview/loaded':
      return action.payload.assignments;
    default:
      return state;
  }
}

export default combineReducers({
  loading,
  failed,
  assignments,
});

export const selectOrganisationUserCareTeamAssignmentPreviewLoading = (state: IState) =>
  state.organisationUserCareTeamPreview.loading;

export const selectOrganisationUserCareTeamAssignmentPreviewFailed = (state: IState) =>
  state.organisationUserCareTeamPreview.failed;

export const selectOrganisationUserCareTeamAssignmentPreview = (state: IState) =>
  state.organisationUserCareTeamPreview.assignments;
